import { TFunction } from 'i18next';
import { z } from 'zod';
import { predicateSchema } from '@/entities/predicate';

export const NEW_ID = '__NEW__' as const;

const createStopWordSchema = (t: TFunction<readonly ['stopWords', 'common']>) => {
  return z.object({
    id: z
      .union([z.number(), z.literal(NEW_ID)])
      .optional()
      .nullable(),
    name: z.string().min(1, t('common:required')),
    predicate: predicateSchema.optional().nullable(),
  });
};

const createStopWordsFormSchema = (t: TFunction<readonly ['stopWords', 'common']>) => {
  return z.object({
    stopWords: z.array(createStopWordSchema(t)),
  });
};

export type StopWordFormValues = z.infer<ReturnType<typeof createStopWordsFormSchema>>;

// Export factory function for use in hooks
export const createStopWordsFormSchemaFactory = (t: TFunction<readonly ['stopWords', 'common']>) =>
  createStopWordsFormSchema(t);
